import { Injectable } from '@angular/core';
import { createClient, EntryCollection } from 'contentful';
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { environment } from 'environments/environment';

const { contentful } = environment;

@Injectable()
export class ContentfulService {
  private cdaClient = contentful.active
    ? createClient({
        space: contentful.space,
        accessToken: contentful.accessToken
      })
    : null;

  constructor() {}

  getFormQuestionInfo(key): Promise<any> {
    if (contentful.active) {
      const locale = this.getLocale();
      return this.cdaClient
        .getEntries({
          content_type: 'toolTip',
          locale,
          'fields.keys': key
        })
        .then((res: EntryCollection<any>) => {
          if (res && res.items.length) {
            return res.items[0].fields['textoDeAyuda'];
          }
        });
    }
    return Promise.resolve(null);
  }

  getPlatformContent(contentKey): Promise<any> {
    if (contentful.active) {
      const locale = this.getLocale();

      return this.cdaClient
        .getEntries({
          content_type: 'platformContent',
          locale,
          'fields.key': contentKey
        })
        .then((res: EntryCollection<any>) => {
          if (res.items.length) {
            const message = res.items[0];
            const content: any = message.fields['content'];
            const options = {
              renderNode: {
                [BLOCKS.PARAGRAPH]: (node, next) => next(node.content)
              }
            };

            return documentToHtmlString(content, options);
          }
          return null;
        })
        .catch(() => {
          return this.cdaClient
            .getEntries({
              content_type: 'platformContent',
              locale: 'en-US',
              'fields.key': contentKey
            })
            .then((res: EntryCollection<any>) => {
              if (res.items.length) {
                const message = res.items[0];
                const content: any = message.fields['content'];
                const options = {
                  renderNode: {
                    [BLOCKS.PARAGRAPH]: (node, next) => next(node.content)
                  }
                };

                return documentToHtmlString(content, options);
              }
              return null;
            });
        });
    }
    return Promise.resolve(null);
  }

  getLocale() {
    const browserLang = navigator.language || 'en';
    const locale = browserLang.substr(0, 2);

    if (locale === 'en') {
      return 'en-US';
    }
    return locale;
  }
}
